import React, { useState, useEffect } from 'react';
import CounsellorNavbar from '../CounsellorLayout/CounsellorNavbar';
import CounsellorSidebar from '../CounsellorLayout/CounsellorSidebar';
import CounsellorFooter from '../CounsellorLayout/CounsellorFooter';
import { Container, Card } from "react-bootstrap";
import { Calendar } from 'react-multi-date-picker';
import "react-multi-date-picker/styles/colors/teal.css"; // Optional: styling
import { API_URL } from "../../../Constant";


const Integrations = () => {
  const [buttonVisible, setButtonVisible] = useState(true);
  const [zoomInfo, setZoomInfo] = useState(null);
  const loginId = localStorage.getItem("loginId");
  useEffect(() => {

    const fetchZoomAccountDetails = async () => {
      try {
        const response = await fetch(
          `${API_URL}api/Counsellor/GetCounselorZoomAccountDetails/${loginId}`
        );

        if (response) {
          setButtonVisible(true);
        }
        else {
          setButtonVisible(false);
        }

        const data = await response.json();
        console.log("Zoom Account Details :", data);

      } catch (error) {
        console.error("Error fetching Zoom Account Details:", error);
      }
    };

    fetchZoomAccountDetails();


  }, []);

  const connectZoom = () => {
    alert("loginId" + loginId);
    // Redirect to backend endpoint to initiate Zoom OAuth.
    // Pass the counsellor's ID (here 1 for example)
    window.location.href = `https://api.psychooncology.online/api/zoom/connect?counselorId=` + { loginId };
  };

  return (
    <>
      <CounsellorNavbar />

      <div className="d-flex">
        <CounsellorSidebar />

        <div style={{ paddingLeft: '30px', width: '100%', paddingBottom: '350px' }}>
          <br></br>
          <h2>Integrations</h2>
          <br></br>



          <button className="btn btn-primary m-2">Connect Google Meet</button>

          <button
            className="btn btn-primary m-2"
            onClick={connectZoom}
            disabled={buttonVisible}
          >
            {buttonVisible == false ? "Connect Zoom Account" : "Connected To Zoom"}
          </button>



        </div>
      </div>
      <CounsellorFooter />
    </>
  );
};

export default Integrations;
